export default "__VITE_ASSET__BYYfGVuu__"